define('rebrush/components/referral/progressbar',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    $,
    _,
    Component,
    BEM
) {
    return Component.create({
        $init: function () {

            this.dashboardTabs = BEM.block('tabs');
            this.tabReferralCode = this.dashboardTabs.getElements('tab--referral-code');
            this.tabReferralRewards = this.dashboardTabs.getElements('tab--referral-rewards');
            this.progressbar = BEM.block('referral-progress-bar');

            this._setProgressBarStep(2);
            this._initializeEvents();
        },
        _initializeEvents: function() {
            var self = this;
            this.tabReferralRewards.on('click', function(e) {
                self._setProgressBarStep(3);
            });
            this.tabReferralCode.on('click', function(e) {
                self._setProgressBarStep(2);
            });
        },
        _setProgressBarStep: function(step) {

            const circleConnector = this.progressbar.getElements('circle-connector');

            const stepCircles = this.progressbar.getElements('circle');

            // const stepCircles = this.progressbar.getElements('circle');

            let currentActive = step ? step : 1;

            stepCircles.each(function (i, circle) {
                if (i < currentActive) {
                    // circle.addModifier('active');
                    if (!circle.className.includes('b_referral-progress-bar__circle--active')) {
                        circle.className = circle.className  + ' b_referral-progress-bar__circle--active';
                    }
                } else {
                    // circle.removeModifier('active');
                    circle.className = circle.className.replaceAll('b_referral-progress-bar__circle--active', '');
                }
            });

            const activeCircles = this.progressbar.getElements('circle--active');

            circleConnector.css('width', ((activeCircles.length - 1) / (stepCircles.length - 1)) * 100 + '%');
        }
    });
});
